import React, { useState } from 'react'

import { Modal } from 'react-bootstrap'

import RequestService from "../../services/request.service";

// import { SERVER_ } from  '../../config';
import moment from 'moment'

import { toast } from 'react-toastify'


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Dialog from '../../services/Dialogs'

const ModalDetalleCobranza = (props) => {

  const dialog = new Dialog();


	const { is_admin, uuid_tramite, onHideModalDetalleCobranza, showModalDetalleCobranza } = props

	const [ detalles_cobranza, setDetalles ] = useState<any>({
		tramite : {
			folio : '',
			idciudadano : {
				nombres : '',
				paterno : '',
				materno : '',
				direccion : '',
				colonia : '',
			}
		},
		cobranza : {
			monto_aseguramiento_final : '',
			sueldo_trabajador_aseguramiento : '',
			fecha_alta_nuevo : '',
			fecha_baja_nuevo : '',
			fecha_aseguramiento : '',
			costo_alta : '',
			fecha_cobro : null
		}
	})

	const cargarDetalles = async ()=>{
		try{
			let res = await RequestService.getEndPoint('mesa_tencion/detalles_cobranza/'+uuid_tramite)
			setDetalles(res.data)
		}
		catch(e){
			toast.error('Error al cargar los detalles')
		}
	}

  React.useEffect(() => {
    cargarDetalles()
  }, []);


  const marcarCobrado =async () =>{
  	try{
  		if(await dialog.confirm('¿Estás seguro?',{})){
	  		let res = await RequestService.update('tramite/fecha_cobro/'+uuid_tramite, { fecha_cobro : moment(dateCobro).format('YYYY-MM-DD'), anexo_cobro : anexo_cobro.split(',')[1] } )
	  		toast.success('Se agrego la fecha de cobro')
	  		cargarDetalles()
	  	}
  	}
  	catch(e){
  		toast.error('Error al marcar la fecha de cobro')
  	}
  }


  const [ dateCobro, setDateCobro] = useState<any>(new Date());



    const [ anexo_cobro, setAnexoCobro ] = useState<any>('')

  const handleFileRead = async (event:any) => {
    const file = event.target.files[0]
    const base64 = await convertBase64(file)
    // var RT = [ ... requisitos_del_tramite ]
    // RT[index].anexo = base64
    setAnexoCobro(base64)
    // console.log(base64)
  }


  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }





	return (

			<React.Fragment>

		      <Modal show={showModalDetalleCobranza} backdrop="static" onHide={onHideModalDetalleCobranza}>
		        <Modal.Header closeButton>
		          <Modal.Title>Detalles de la Cobranza</Modal.Title>
		        </Modal.Header>
		        <Modal.Body>
		        	

						<p>FOLIO <b>{detalles_cobranza.tramite.folio||'S/F'}</b></p>

						<h6>Información de Contacto</h6>
						<dl>
						    <dt>Nombre</dt>
						    <dd><b>{detalles_cobranza.tramite.idciudadano.nombres}</b> {detalles_cobranza.tramite.idciudadano.paterno} {detalles_cobranza.tramite.idciudadano.materno}</dd>

						    <dt>Teléfono</dt>
						    <dd>{detalles_cobranza.tramite.idciudadano.telefono||'No proporcionado'}</dd>

						    <dt>Celular</dt>
						    <dd>{detalles_cobranza.tramite.idciudadano.celular||'No proporcionado'}</dd>

						    <dt>Dirección</dt>
						    <dd>{detalles_cobranza.tramite.idciudadano.direccion||'No proporcionado'}</dd>

						    <dt>Colonia</dt>
						    <dd>{detalles_cobranza.tramite.idciudadano.colonia||'No proporcionado'}</dd>

						</dl>


						{
							is_admin &&(

								<React.Fragment>
									
										<hr/>

										<h6>Información de Cobranza</h6>
										<dl>
										    <dt>Monto de Aseguramiento Cobrado</dt>
										    <dd>$ {detalles_cobranza.cobranza?.monto_aseguramiento_final}</dd>

										    <dt>Sueldo de Aseguramiento del Trabajador</dt>
										    <dd>$ {detalles_cobranza.cobranza?.sueldo_trabajador_aseguramiento}</dd>
										    <dt>Fecha de Alta del Nuevo Trabajo</dt>
										    <dd>{detalles_cobranza.cobranza?.fecha_alta_nuevo}</dd>
										    <dt>Fecha de Baja del Nuevo Trabajo</dt>
										    <dd>{detalles_cobranza.cobranza?.fecha_baja_nuevo}</dd>
										    <dt>Fecha de Aseguramiento</dt>
										    <dd>{detalles_cobranza.cobranza?.fecha_aseguramiento}</dd>
										    <dt>Costo del Alta</dt>
										    <dd>$ {detalles_cobranza.cobranza?.costo_alta}</dd>

										    {
										    	detalles_cobranza.cobranza?.fecha_cobro && (
										    		<React.Fragment>
													    <dt>Fecha de Cobro</dt>
													    <dd>{detalles_cobranza.cobranza?.fecha_cobro}</dd>
										    		</React.Fragment>
										    	)
										    }

										</dl>


										{
											(detalles_cobranza.cobranza?.fecha_cobro)  && (
												<React.Fragment>

															<div className="alert alert-warning" role="alert">
															  ESTE TRÁMITE YA FUE COBRADO
															</div>

												</React.Fragment>
											)
										}



										{
											(!detalles_cobranza.cobranza?.fecha_cobro)  && (
												<React.Fragment>

										<div className="alert alert-warning" role="alert">
										  <h4 className="alert-heading">Cobro</h4>
										  <p>¿El trámite ya fue cobrado? Marca la fecha de cobro</p>

										  <div className="mb-3">
										    <label htmlFor="exampleInputEmail1" className="form-label">Fecha de Cobro</label>
										    <DatePicker className="form-control" selected={dateCobro} inline maxDate={new Date()} dateFormat="yyyy-MMMM-dd" onChange={(date) => { setDateCobro(date); }} />
										  </div>



										  <div className="mb-3">
										    <label htmlFor="exampleInputEmail1" className="form-label">Ficha de Deposito / Comprobante</label>
										    <input type="file" accept="image/jpeg,image/jpg,image/png" onChange={handleFileRead} />
										  </div>





										  {
										  	(dateCobro && anexo_cobro !== '') && (
										  		<button onClick={()=>{marcarCobrado()}} type="button" className="btn btn-primary">Marcar como Liquidado</button>
										  	)
										  }
										  


										</div>


												</React.Fragment>
											)
										}


								</React.Fragment>

							)
						}



				{
					// JSON.stringify(uuid_tramite)
				}
				{
					// JSON.stringify(detalles_cobranza.cobranza?)
				}

		        </Modal.Body>
		      </Modal>

			</React.Fragment>

		)

}

export default ModalDetalleCobranza